"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return AxisValidators;
    }
});
var _axisSchema = require("../schemas/AxisSchema");
var _baseCustomValidators = /*#__PURE__*/ _interopRequireDefault(require("./BaseCustomValidators"));
var _typeValidators = /*#__PURE__*/ _interopRequireDefault(require("./TypeValidators"));
var _valueValidators = /*#__PURE__*/ _interopRequireDefault(require("./ValueValidators"));
var _motorSettings = /*#__PURE__*/ _interopRequireDefault(require("../schemas/external/MotorSettings"));
var _errors = require("../errors");
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var AxisValidators = /*#__PURE__*/ function(BaseCustomValidators) {
    "use strict";
    _inherits(AxisValidators, BaseCustomValidators);
    var _super = _createSuper(AxisValidators);
    function AxisValidators() {
        _classCallCheck(this, AxisValidators);
        return _super.apply(this, arguments);
    }
    AxisValidators.isNema17Motor = function isNema17Motor(motorSize) {
        return /Nema 17/i.test(motorSize);
    };
    AxisValidators.isBrakePresent = function isBrakePresent(brake) {
        return /present/i.test(brake);
    };
    AxisValidators.validate = function validate(paramInfo, value, allParameters) {
        var result = {
            isValid: true
        };
        var validationMethod = AxisValidators.paramToValidatorMapping[paramInfo.name];
        if (validationMethod === undefined) return result;
        var validation = validationMethod(value, allParameters);
        return _objectSpread({}, result, validation);
    };
    AxisValidators.validateAxisType = function validateAxisType(value, allParameters) {
        var isMotorSizeValid = AxisValidators._validateMotorSizeSupportsAxisType(allParameters);
        var isHomingSpeedValid = AxisValidators._validateAxisTypeSupportsHomingSpeed(allParameters);
        var errors = [];
        if (!isMotorSizeValid) errors.push(_errors.AxisErrors.MOTOR_SIZE_DOES_NOT_SUPPORT_AXIS_TYPE);
        if (!isHomingSpeedValid) errors.push(_errors.AxisErrors.AXIS_TYPE_DOES_NOT_SUPPORT_HOMING_SPEED);
        return {
            isValid: isMotorSizeValid && isHomingSpeedValid,
            errors: errors
        };
    };
    AxisValidators.validateBrakes = function validateBrakes(value, allParameters) {
        var isMotorSizeValid = AxisValidators._validateMotorSizeSupportsBrakes(allParameters);
        return {
            isValid: isMotorSizeValid,
            errors: !isMotorSizeValid ? [
                _errors.AxisErrors.MOTOR_SIZE_DOES_NOT_SUPPORT_BRAKES
            ] : []
        };
    };
    AxisValidators.validateHomingSpeed = function validateHomingSpeed(value, allParameters) {
        var isHomingSpeedValid = AxisValidators._validateAxisTypeSupportsHomingSpeed(allParameters);
        return {
            isValid: isHomingSpeedValid,
            errors: !isHomingSpeedValid ? [
                _errors.AxisErrors.AXIS_TYPE_DOES_NOT_SUPPORT_HOMING_SPEED
            ] : []
        };
    };
    AxisValidators.validateChildrenDrives = function validateChildrenDrives(value) {
        var isValid = true;
        var childrenDrivesParamInfo = _axisSchema.schemaMap.parameters.childrenDrives.unit;
        var drivesValidation = value.map(function(drive, index) {
            var isDriveValid = true;
            var validation = childrenDrivesParamInfo.map(function(paramInfo) {
                var isValidType = _typeValidators.default.validate(paramInfo, drive[paramInfo.name]);
                var isValidValue = isValidType && _valueValidators.default.validate(paramInfo, drive[paramInfo.name]);
                var errors = [];
                if (!isValidValue) {
                    isValid = false;
                    isDriveValid = false;
                    errors.push(!isValidType ? _errors.ParameterErrors.PARAMETER_TYPE_INVALID : _errors.ParameterErrors.PARAMETER_VALUE_INVALID);
                }
                return {
                    name: paramInfo.name,
                    isValid: isValidValue,
                    errors: errors
                };
            });
            return {
                name: "child drive ".concat(index),
                isValid: isDriveValid,
                validation: validation
            };
        });
        return {
            isValid: isValid,
            errorContext: {
                drivesValidation: drivesValidation
            }
        };
    };
    AxisValidators.validateMotorCurrent = function validateMotorCurrent(value, allParameters) {
        if (!_motorSettings.default[allParameters.motorSize]) return {
            isValid: false
        };
        var minimum = _motorSettings.default[allParameters.motorSize].motorCurrent.minimum;
        var maximum = _motorSettings.default[allParameters.motorSize].motorCurrent.maximum;
        var isValid = value >= minimum && value <= maximum;
        var errors = [];
        if (!isValid) {
            errors.push(_errors.AxisErrors.MOTOR_CURRENT_OUT_OF_RANGE);
        }
        return {
            isValid: isValid,
            errors: errors,
            errorContext: {
                minimum: minimum,
                maximum: maximum
            }
        };
    };
    AxisValidators.validateMotorSize = function validateMotorSize(value, allParameters) {
        var isBrakeValid = AxisValidators._validateMotorSizeSupportsBrakes(allParameters);
        var isAxisValid = AxisValidators._validateMotorSizeSupportsAxisType(allParameters);
        var errors = [];
        if (!isBrakeValid) errors.push(_errors.AxisErrors.MOTOR_SIZE_DOES_NOT_SUPPORT_BRAKES);
        if (!isAxisValid) errors.push(_errors.AxisErrors.MOTOR_SIZE_DOES_NOT_SUPPORT_AXIS_TYPE);
        return {
            isValid: isBrakeValid && isAxisValid,
            errors: errors
        };
    };
    AxisValidators._validateMotorSizeSupportsBrakes = function _validateMotorSizeSupportsBrakes(allParameters) {
        return !(AxisValidators.isNema17Motor(allParameters.motorSize) && AxisValidators.isBrakePresent(allParameters.brake));
    };
    AxisValidators._validateMotorSizeSupportsAxisType = function _validateMotorSizeSupportsAxisType(allParameters) {
        return _motorSettings.default[allParameters.motorSize] && _motorSettings.default[allParameters.motorSize].allowedAxisType.includes(allParameters.axisType);
    };
    AxisValidators._validateAxisTypeSupportsHomingSpeed = function _validateAxisTypeSupportsHomingSpeed(allParameters) {
        if (_axisSchema.schemaMap.parameters.axisType.maxSpeedMapping[allParameters.axisType] === undefined) return true;
        return allParameters.homingSpeed <= _axisSchema.schemaMap.parameters.axisType.maxSpeedMapping[allParameters.axisType];
    };
    return AxisValidators;
}(_baseCustomValidators.default);
AxisValidators.paramToValidatorMapping = {
    axisType: AxisValidators.validateAxisType,
    brake: AxisValidators.validateBrakes,
    childrenDrives: AxisValidators.validateChildrenDrives,
    motorCurrent: AxisValidators.validateMotorCurrent,
    motorSize: AxisValidators.validateMotorSize,
    homingSpeed: AxisValidators.validateHomingSpeed
};
